<template>
    <div class="row">
        <div class="col-xs-12">
            <h1 class="page-header">
                Editar Ação
            </h1>
            <div class="row">
                <div class="col-xs-12">
                    <div class="col-xs-12">
                        <SelectFuncionario
                            v-model="model.sshd_responsavel"
                            :label="'Funcionário Responsável'"
                            ref="SelectFuncionario"
                            :name="'sshd_responsavel'"
                            :placeholder="'Pesquise pelo nome ou SSHD'"
                            :is-required="true"
                        />
                    </div>

                    <div class="col-xs-16 col-sm-6">
                        <div :class="['form-group', { 'has-error' : errors.has('ordem') }]">
                            <label class="control-label custom-font">Ordem</label>
                            <div class="inputgroupcontainer">
                                <div class="input-group">
                                    <span class="input-group-addon">
                                        <font-awesome-icon :icon="'list-ol'" />
                                    </span>
                                    <input 
                                        ref="ordem" 
                                        v-model="model.ordem" 
                                        type="number"
                                        min="1"
                                        class="form-control" 
                                        placeholder="Ordem da ação"
                                        name="ordem"
                                        v-validate="'required|numeric'"
                                    />
                                </div>
                            </div>
                            <small 
                                v-if="errors.has('ordem')" 
                                data-bv-validator="notempty"
                                data-bv-validator-for="ordem" 
                                class="help-block"
                            >
                                Preenchimento obrigatório!
                            </small>
                        </div>
                    </div>

                    <div class="col-xs-12 col-sm-6">
                        <div :class="['form-group', { 'has-error': errors.has('unidade') }]">
                            <label class="control-label custom-font">Unidade</label>
                            <div class="inputgroupcontainer">
                                <div class="input-group">
                                    <span class="input-group-addon">
                                        <font-awesome-icon :icon="'sitemap'" />
                                    </span>
                                    <select 
                                        ref="unidade"
                                        name="unidade" 
                                        class="form-control select-selected"
                                        v-model="model.unidade"
                                        v-validate="'required'"
                                    >
                                        <option disabled value="">Selecione a unidade</option>

                                        <optgroup label="Secretarias">
                                            <option v-for="s in listas.secretarias" :key="s.sigla" :value="s.sigla" :title="s.nome">
                                                {{ s.sigla }}
                                            </option>
                                        </optgroup>

                                        <optgroup label="Autarquias">
                                            <option v-for="a in listas.autarquias" :key="a.sigla" :value="a.sigla" :title="a.nome">
                                                {{ a.sigla }}
                                            </option>
                                        </optgroup>
                                    </select>
                                </div>
                                <small 
                                    v-if="errors.has('unidade')" 
                                    data-bv-validator="notempty"
                                    data-bv-validator-for="unidade" 
                                    class="help-block"
                                >
                                    Preenchimento obrigatório!
                                </small>
                            </div>
                        </div>
                    </div>

                    <div v-if="compromisso.unidade_executora === model.unidade" class="col-xs-12">
                        <div class="row">
                            <div class="col-xs-12 col-sm-6">
                                <div class="form-group">
                                    <label class="control-label custom-font">Data de início estimada</label>
                                    <div class="input-group">
                                        <span class="input-group-addon">
                                            <font-awesome-icon :icon="'calendar-alt'" />
                                        </span>
                                        <datepicker v-model="model.data_estimada_inicio" />
                                    </div>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-6">
                                <div class="form-group">
                                    <label class="control-label custom-font">Data de conclusão estimada</label>
                                    <div class="input-group">
                                        <span class="input-group-addon">
                                            <font-awesome-icon :icon="'calendar-alt'" />
                                        </span>
                                        <datepicker v-model="model.data_estimada_conclusao" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-xs-12">
                        <div :class="['form-group', { 'has-error': errors.has('descritivo') }]">
                            <label class="control-label custom-font">Descritivo</label>
                            <div class="inputgroupcontainer">
                                <div class="input-group">
                                    <span class="input-group-addon">
                                        <font-awesome-icon :icon="'comment'"></font-awesome-icon>
                                    </span>
                                    <textarea 
                                        ref="descritivo" 
                                        v-model="model.descritivo" 
                                        placeholder="Descreva a ação..." 
                                        maxlength="1000" 
                                        class="form-control"
                                        v-validate="'required'" 
                                        name="descritivo"
                                        rows="8"
                                    ></textarea>
                                    <div class="input-group-addon custom-input-group-addon-count" v-text="1000 - (model.descritivo || '').length"></div>
                                </div>
                            </div>
                            <small
                                v-if="errors.has('descritivo')"
                                data-bv-validator="notempty"
                                data-bv-validator-for="descritivo"
                                class="help-block"
                            >
                                Preenchimento obrigatório!
                            </small>
                        </div>
                    </div>

                    <div v-show="model.unidade !== compromisso.unidade_executora" class="col-xs-12">
                        <div :class="['form-group', { 'has-error': errors.has('justificativa_criacao') }]">
                            <label class="control-label custom-font">Justificativa de Criação</label>
                            <div class="inputgroupcontainer">
                                <div class="input-group">
                                    <span class="input-group-addon">
                                        <font-awesome-icon :icon="'comment'" />
                                    </span>
                                    <textarea 
                                        ref="justificativa_criacao" 
                                        v-model="model.justificativa_criacao" 
                                        placeholder="Justifique a criação da ação..." 
                                        maxlength="1000" 
                                        class="form-control"
                                        v-validate="{ required: model.unidade !== compromisso.unidade_executora }" 
                                        name="justificativa_criacao"
                                        rows="8"
                                    ></textarea>
                                    <div class="input-group-addon custom-input-group-addon-count" v-text="1000 - (model.justificativa_criacao || '').length"></div>
                                </div>
                            </div>
                            <small
                                v-if="errors.has('justificativa_criacao')"
                                data-bv-validator="notempty"
                                data-bv-validator-for="justificativa_criacao"
                                class="help-block"
                            >
                                Preenchimento obrigatório!
                            </small>
                        </div>
                    </div>

                    <div class="col-xs-12 margem-bottom">
                        <button
                            type="button"
                            class="btn btn-default"
                            @click="$router.back()"
                        >
                            <font-awesome-icon 
                                :icon="'long-arrow-alt-left'" 
                                :class="'fa-long-arrow-alt-left-white'" 
                            /> Voltar
                        </button>

                        <button type="button" class="btn btn-default" @click="validar()">
                            <font-awesome-icon :icon="'save'" :class="'fa-save-white'" /> Salvar
                        </button>
                    </div>
                </div>
            </div>

            <SideAcao
                ref="side"
                :navs="sideConfig"
                @confirmarReordenacao="save()"
            />
        </div>
    </div>
</template>

<script>
import SideAcao from '@/components/planogoverno/SideAcao.vue'
import { request } from '@/request'
import datepicker from '@/components/common/Datepicker'
import SelectFuncionario from '@/components/SelectFuncionario'

export default {
    name: 'compromisso-acoes-edit',
    props: ['id'],
    inject: ["showConfirm"],
    components: {
        datepicker,
        SelectFuncionario,
        SideAcao
    },
    data() {
        return {
            listas: {
                secretarias: [],
                autarquias: [],
                ordensExistentes: [],
            },
            compromisso: {},
            model: {
                id: null,
                compromisso_id: null,
                unidade: '',
                nome_unidade: '',
                sshd_responsavel: '',
                user_sshd: '',
                ordem: null,
                descritivo: '',
                data_estimada_inicio: null,
                data_inicio: null,
                data_estimada_conclusao: null,
                data_conclusao: null,
                status: '',
                justificativa_criacao: '',
                justificativa_rejeicao: '',
            },
            sideConfig: [
                {
                    titulo: 'Confirmar Ordem',
                    subtitulo: '',
                    subtDetalhe: '',
                    largura: 500,
                    identidade: 'reordenar',
                    abreProximo: false,
                    aberto: false,
                    data: null
                },
            ],
        }
    },
    async created() {
        await this.getAcaoData()
        this.loadUnidades()
        this.loadUser()
    },
    watch: {
        'model.unidade': function (novaSigla, siglaAntiga) {
            if (novaSigla && novaSigla !== siglaAntiga) {
                this.loadNomeUnidade();
            }
        }
    },
    computed: {
        isUpdate() {
            return this.model.hasOwnProperty('codigo')
        },
        isAdd() {
            return !this.isUpdate
        },
        urlToSave() {
            return this.isUpdate ? 'planogoverno/update' : 'planogoverno/add'
        },
    },
    methods: {
        saveSuccess(result) {
            this.$router.back()
            this.$toastr.s('A ação foi salva com sucesso.')
        },
        saveFail(result) {
            this.$toastr.e('Houve uma falha ao tentar salvar este item.')
        },
        async getOrdensExistentes() {
            if (!this.model.compromisso_id) return;
            try {
                const { data, status } = await request.get(`planogoverno/compromisso-acao?compromisso_id=${this.model.compromisso_id}&all=true`);
                if (status === 200) {
                    this.listas.ordensExistentes = data.map(acao => ({ 
                        id: acao.id, 
                        ordem: acao.ordem 
                    }));
                } else {
                    this.$toastr.e('Erro ao carregar ordens existentes.');
                }
            } catch (err) {
                console.error('Erro ao buscar ordens existentes:', err);
                this.$toastr.e('Erro ao buscar ordens existentes.');
            }
        },
        async validar() {
            const isValid = await this.$validator.validateAll();
            if (!isValid) {
                const campoComErro = this.$validator.errors.items[0].field

                if (campoComErro === 'sshd_responsavel') {
                    this.$refs.SelectFuncionario.$el.querySelector('input').focus()
                } else {
                    this.$refs[campoComErro].focus()
                }

                let msg = this.$validator.errors.items[0].msg       
                this.$toastr.e(msg)
                return
            }

            const ordemNumerica = parseInt(this.model.ordem, 10);
            const ordemExistes = this.listas.ordensExistentes.some(o => o.ordem === ordemNumerica && o.id !== this.model.id);
            
            if (ordemExistes) {
                const painel = this.sideConfig.find(p => p.identidade === 'reordenar')
                painel.data = { ordem: this.model.ordem }
                this.$refs.side.$emit('abreModal', 'reordenar');
            } else {
                this.save()
            }
        },
        async save() {
            this.$refs.side.$emit('fechaModal', 'reordenar');

            if (this.compromisso.unidade_executora !== this.model.unidade) {
                this.model.data_estimada_inicio = null
                this.model.data_estimada_conclusao = null
            } else {
                this.model.justificativa_criacao = null

                if (!this.validateDates()) {
                    return
                }

                if (this.model.data_estimada_inicio) {
                    this.model.data_estimada_inicio = this.formatDate(new Date(this.model.data_estimada_inicio));
                }
                if (this.model.data_estimada_conclusao) {
                    this.model.data_estimada_conclusao = this.formatDate(new Date(this.model.data_estimada_conclusao));
                }
                if (this.model.data_inicio) {
                    this.model.data_inicio = this.formatDate(new Date(this.model.data_estimada_inicio));
                }
                if (this.model.data_conclusao) {
                    this.model.data_conclusao = this.formatDate(new Date(this.model.data_estimada_conclusao));
                }
            }

            try {
                const response = await request.put(`planogoverno/compromisso-acao/${this.model.id}`, { ...this.model })
                if (response.status !== 200) {
                    return this.saveFail()
                }
                return this.saveSuccess()
            } catch (error) {
                console.error('Houve uma falha ao tentar alterar a ação: ', error.response ? error.response.data : error.message)
                return this.saveFail()
            }
        },
        validateDates() {
            if (this.model.data_estimada_inicio && this.model.data_estimada_conclusao) {
                const inicio = new Date (this.model.data_estimada_inicio)
                const termino = new Date(this.model.data_estimada_conclusao)
                if (termino < inicio) {
                    this.$toastr.e("A data prevista de conclusão não pode ser menor que a data de início")
                    return false
                }
            }
            return true
        },
        formatDate(date) {
            const year = date.getFullYear()
            const month = ('0' + (date.getMonth() + 1)).slice(-2)
            const day = ('0' + date.getDate()).slice(-2)
            const hour = ('0' + date.getHours()).slice(-2)
            const minute = ('0' + date.getMinutes()).slice(-2)
            const second = ('0' + date.getSeconds()).slice(-2)

            return `${year}-${month}-${day} ${hour}:${minute}:${second}`
        },
        async getCompromissoData() {
            try {
                const { data } = await request.get(`planogoverno/compromisso/${this.model.compromisso_id}`);
                this.compromisso = data;
            } catch (error) {
                console.error("Erro ao buscar compromisso:", error);
                this.$toastr.e('Erro ao carregar os dados do compromisso.');
            }
        },
        async getAcaoData() {
            const { data } = await request.get(`planogoverno/compromisso-acao/${this.id}`)
            
            if (data.data_estimada_conclusao) {
                const [dia, mes, ano] = data.data_estimada_conclusao.split('/');
                data.data_estimada_conclusao = new Date(ano, mes - 1, dia);
            }
            if (data.data_estimada_inicio) {
                const [dia, mes, ano] = data.data_estimada_inicio.split('/');
                data.data_estimada_inicio = new Date(ano, mes - 1, dia);
            }

            Object.assign(this.model, data);

            await this.getCompromissoData()
            await this.getOrdensExistentes()
        },
        async loadUnidades() {
            const { data: { data: secretarias } } = await request.get('listar-secretarias')
            const { data: { data: autarquias } } = await request.get('listar-autarquias')

            this.listas.secretarias = secretarias
            this.listas.autarquias = autarquias
        },
        async loadUser() {
            if (this.$store.state.user.username) {
                this.model.user_sshd = this.$store.state.user.username
            } else {
                this.$toastr.e('Houve um erro ao tentar carregar o sshd do usuário!')
            }
        }
    }
}
</script>

<style scoped>
.custom-font {
    font-size: 16px;
    color: #00615c;
}

.custom-meta {
    color: #00615c;
}

.select-selected {
    color: #00615c;
}

.custom-input-group-addon-count {
    color: #00615c;
}

.fa-sitemap {
    color: #00615c;
}

.fa-user {
    color: #00615c;
}

.fa-check-double-white {
    color: #fff;
}

.fa-tags {
    color: #00615c;
}

.fa-comment {
    color: #00615c;
}

.fa-save-white {
    color: #fff;
}

.fa-long-arrow-alt-left-white {
    color: #fff;
}

.btn-voltar {
    margin-top: 20px;
}

.fa-calendar-alt {
    color: #00615c;
}

.list-group img {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/plano-governo/acao/Edit.vue